import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'

var rsaUtil = {
  // RSA 位数  1024，这里要跟后端对应
  bits: 512,
  // 当前JSEncrypted对象
  thisKeyPair: {},
}
export default {
  // 极验
  initgt4(captchaId, callback) {
    initGeetest4(
      {
        captchaId: captchaId,
        // captchaId: '6f36ff50384139b86f4d4f4905b9185c',
        product: 'bind',
        language: 'zho',
        riskType: 'slide',
        mask: {
          outside: false,
        },
        // rem: 0.8
      },
      function (captcha) {
        // captcha为验证码实例
        captcha
          .onReady(function () {})
          .onSuccess(function () {
            var validate = captcha.getValidate()
            if (validate) {
              callback(captcha, validate)
            }
          })
          .onError(function () {})
        captcha.onClose(function () {
          callback(captcha, 'close')
        })
        captcha.showCaptcha()
      }
    )
  },
  // 获取aeskey，
  genak(length = 12) {
    let random =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let str = ''
    for (let i = 0; i < length; i++) {
      str = str + random.charAt(Math.random() * random.length)
    }
    return str
  },

  // aes加密
  ae(plaintext, key) {
    // if (plaintext instanceof Object) {
    // // JSON.stringify
    //   plaintext = JSON.stringify(plaintext)
    // }
    let encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(plaintext),
      CryptoJS.enc.Utf8.parse(key),
      { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    )
    return encrypted.toString()
  },

  // aes 解密
  ad(ciphertext, key) {
    let decrypt = CryptoJS.AES.decrypt(
      ciphertext,
      CryptoJS.enc.Utf8.parse(key),
      { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    )
    let decString = CryptoJS.enc.Utf8.stringify(decrypt).toString()
    // if (decString.charAt(0) === '{' || decString.charAt(0) === '[') {
    // // JSON.parse
    //   decString = JSON.parse(decString)
    // }
    return decString
  },

  // 生成rsa密钥对(公钥和私钥)
  genrp(bits = rsaUtil.bits) {
    let genKeyPair = {}
    rsaUtil.thisKeyPair = new JSEncrypt({ default_key_size: bits })
    // 获取私钥
    genKeyPair.privateKey = rsaUtil.thisKeyPair.getPrivateKey()
    // 获取公钥
    genKeyPair.publicKey = rsaUtil.thisKeyPair.getPublicKey()
    return genKeyPair
  },
  // 公钥加密
  re(plaintext, publicKey) {
    // 由于没有genRsaKeyPair，所以需要执行下面这句
    rsaUtil.thisKeyPair = new JSEncrypt({ default_key_size: rsaUtil.bits })
    if (plaintext instanceof Object) {
      plaintext = JSON.stringify(plaintext)
    }

    publicKey && rsaUtil.thisKeyPair.setPublicKey(publicKey)
    return rsaUtil.thisKeyPair.encrypt(plaintext)
  },

  // 私钥解密
  rd(ciphertext, privateKey) {
    privateKey && rsaUtil.thisKeyPair.setPrivateKey(privateKey)
    let decString = rsaUtil.thisKeyPair.decrypt(ciphertext)
    // if (decString.charAt(0) === '{' || decString.charAt(0) === '[') {
    //   // JSON.parse
    //   decString = JSON.parse(decString)
    // }
    return decString
  },
  // 加密解密方法：string-需要解密的字段  code-约定的密钥    operation 默认false表示加密，传入true表示解密
  secret(string, code, operation) {
    if (string instanceof Object) {
      // JSON.stringify
      string = JSON.stringify(string)
    }
    code = CryptoJS.MD5(code).toString()
    var iv = CryptoJS.enc.Utf8.parse(code.substring(0, 16))
    var key = CryptoJS.enc.Utf8.parse(code.substring(16))
    if (operation) {
      return CryptoJS.AES.decrypt(string, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
      }).toString(CryptoJS.enc.Utf8)
    }
    return CryptoJS.AES.encrypt(string, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString()
  },
  getPng(str) {
    // 得到正确路径的图片
    return process.env.VUE_APP_CDN_URL_PIC + '/fm2023/' + str + '.png'
  },
  getPng2(str) {
    // 得到正确路径的图片
    return (
      process.env.VUE_APP_CDN_URL_PIC + '/fm2023/web4/daren/' + str + '.png'
    )
  },
  setCookie(name, value, second) {
    var timestr = ''
    if (second > 0) {
      var exp = new Date()
      exp.setTime(exp.getTime() + 1000 * second)
      timestr = ';expires=' + exp.toGMTString()
    }
    document.cookie = name + '=' + escape(value) + timestr
  },
  getCookie(name) {
    var arrt = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    )
    if (arrt) {
      return unescape(arrt[2])
    } else {
      return localStorage.getItem('shortToken') || null
    }
  },
  clearCookie(cname) {
    var cd = new Date()
    cd.setTime(cd.getTime() - 1)
    document.cookie = cname + '=-1;expires=' + cd.toUTCString()
    // window.document.cookie = cname + '=del;path=/;expires=-1'
  },
  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // 转义正则特殊字符
  },
  // 替换搜索颜色
  getSearchKeyword(keyword, desc, color, margin = '0 2px') {
    if (desc) {
      const escapedDesc = this.escapeRegExp(desc) // 转义 desc 里的特殊字符（如 +）
      const regex = new RegExp(`(${escapedDesc})`, 'g')
      const highlightedText = keyword.replace(
        regex,
        `<span style="color: ${color};margin: ${margin};">$1</span>`
      )
      return highlightedText
    }
    return keyword
  },
}
